import React from "react";
import styled from "styled-components";

import EkomiRating from "../EkomiRating";
import Layer from "../Layer";
import Logo from "../Logo";
import ResponsiveContainer from "../ResponsiveContainer";
import Spacings from "../Spacings";
import VerticalFlag, { VERTICAL_FLAG_WIDTH } from "../VerticalFlag";

import Layout from "./Layout";

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AccountLinkWrapper = styled.div`
  margin-left: ${(props) => props.theme.spacings.big};
  @media (min-width: ${(props) => props.theme.layout.mobileBreakpoint}) {
    padding-right: calc(
      ${(props) => props.theme.spacings.big} + ${VERTICAL_FLAG_WIDTH}
    );
    margin-right: ${(props) => props.theme.spacings.small};
  }
  @media (min-width: ${(props) =>
      props.theme.layout.containerWidthBreakpoint}) {
    margin-right: 0;
  }
`;

const PhoneNumberWrapper = styled.div`
  margin-left: auto;
  @media (min-width: ${(props) => props.theme.layout.mobileBreakpoint}) {
    margin-left: 0;
  }
`;

export type HeaderProps = {
  accountLink?: React.ReactNode;
  ekomiFlag: React.ReactNode;
  ekomiImageBig: React.ReactNode;
  ekomiImageSmall?: React.ReactNode;
  guidanceStepper?: React.ReactNode;
  logoWithLink?: React.ReactNode;
  phoneNumber?: React.ReactNode;
};

export const Header: React.FC<React.PropsWithChildren<HeaderProps>> = ({
  accountLink,
  ekomiFlag,
  ekomiImageBig,
  ekomiImageSmall,
  guidanceStepper,
  logoWithLink,
  phoneNumber,
}) => (
  <Layout.Grid>
    {ekomiImageBig && ekomiFlag ? (
      <Layout.FlagContainer>
        <Layout.Flag>
          <VerticalFlag>
            <Spacings.Stack alignItems="center">
              {ekomiImageBig}
              {ekomiFlag}
              <EkomiRating isCondensed scale="tiny" />
            </Spacings.Stack>
          </VerticalFlag>
        </Layout.Flag>
      </Layout.FlagContainer>
    ) : null}
    <Layout.Background>
      <Layer.Raised />
    </Layout.Background>
    <Layout.Main>
      <Spacings.Inset>
        <HeaderContent>
          {logoWithLink ? (
            logoWithLink
          ) : (
            <a
              href={"/"}
              data-testid="logo"
              aria-label="Finanzchef24 GmbH Homepage"
            >
              <Logo />
            </a>
          )}
          {ekomiImageSmall && ekomiFlag ? (
            <ResponsiveContainer showOn={["mobile"]}>
              <Spacings.Inline alignItems="center">
                {ekomiImageSmall}
                <Spacings.Stack>
                  {ekomiFlag}
                  <EkomiRating isCondensed scale="tiny" />
                </Spacings.Stack>
              </Spacings.Inline>
            </ResponsiveContainer>
          ) : null}

          {phoneNumber && (
            <PhoneNumberWrapper>{phoneNumber}</PhoneNumberWrapper>
          )}
          {accountLink ? (
            <AccountLinkWrapper>{accountLink}</AccountLinkWrapper>
          ) : null}
        </HeaderContent>
      </Spacings.Inset>
      {guidanceStepper ? guidanceStepper : null}
    </Layout.Main>
  </Layout.Grid>
);

export default Header;
